import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getProjects, Project } from '../services/api';

const ProjectsList = () => {
    const [projects, setProjects] = useState<Project[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const data = await getProjects();
                setProjects(data);
            } catch (err) {
                setError('Failed to fetch projects.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    if (loading) {
        return <div>Loading projects...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div>
            <h2>Projects</h2>
            {projects.length === 0 ? (
                <p>No projects found. <Link to="/projects/new">Create a new one</Link>.</p>
            ) : (
                <ul>
                    {projects.map((project) => (
                        <li key={project.project_id}>
                            <Link to={`/projects/${project.project_id}`}>{project.name}</Link>
                            <p>{project.description || 'No description'}</p>
                            <small>Last updated: {new Date(project.updated_at).toLocaleString()}</small>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ProjectsList;